export function initContactFormLabels() {
	const formControls = document.querySelectorAll(
		'.wpcf7-form-control:not(.wpcf7-submit):not(.wpcf7-select)'
	);

	formControls.forEach((control) => {
		const labelId = control.getAttribute('id');
		const associatedLabel = document.querySelector(
			`label[for="${labelId}"]`
		);

		if (!associatedLabel) {
			return;
		}

		control.addEventListener('focus', () => {
			associatedLabel.classList.add('show');
			const notValidTip = control.nextElementSibling;
			if (
				notValidTip &&
				notValidTip.classList.contains('wpcf7-not-valid-tip')
			) {
				notValidTip.remove();
			}
		});

		control.addEventListener('blur', () => {
			associatedLabel.classList.remove('show');
		});
	});
}
